import { render, staticRenderFns } from "./QuestionMasteryTrendMobile.vue?vue&type=template&id=5b8856db&scoped=true"
import script from "./QuestionMasteryTrendMobile.vue?vue&type=script&lang=js"
export * from "./QuestionMasteryTrendMobile.vue?vue&type=script&lang=js"
import style0 from "./QuestionMasteryTrendMobile.vue?vue&type=style&index=0&id=5b8856db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8856db",
  null
  
)

export default component.exports